import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";
import { put } from "../../common/api/apiShared";
import { SystemNotificationViewModel } from "./PublishedSystemNotificationDialog.types";
import { useOptimisticUpdate } from "@common/hooks/useOptimisticUpdate";

export function usePublishedSystemNotificationDialog() {
    const { data: systemNotification } = useDotLegalQueryWithKey<SystemNotificationViewModel>("systemNotification", "/notification/systemNotification");
    const { putOnQueueAndSetQueryData } = useOptimisticUpdate();

    const showDialog = systemNotification?.hasUnreadNotification ?? false;

    function markAsRead(id: string) {
        return put<string>(`/notification/${id}/markasread`, true);
    }

    const handleClose = async () => {
        if (systemNotification) {
            await putOnQueueAndSetQueryData({ ...systemNotification, hasUnreadNotification: false }, "systemNotification", markAsRead, systemNotification.id);
        }
    };

    return {
        systemNotification,
        showDialog,
        handleClose,
    };
}
